import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactSound from 'react-sound';
import { connect } from 'react-redux';

import { useImagesContext } from '../../contexts/ImagesContext';
import { ImgClick } from '../utility';
import { getWanderlandsOfStudent } from '../../services/wanderland';

import backgroundSound from './sounds/background.mp3';

const STAGES_POSITION = [
  { left: 19, top: 796 },
  { left: 529, top: 979 },
  { left: 280, top: 600 },
  { left: 28, top: 343 },
  { left: 450, top: 180 },
  { left: 1530, top: 970 },
  { left: 1048, top: 712 },
  { left: 1350, top: 530 },
  { left: 1060, top: 345 },
  { left: 1543, top: 285 },
];

const WanderlandItem = ({ title, lock, left, top, onClick }) => {
  const { images } = useImagesContext();
  // console.debug('title', title);
  return (
    <ItemBlock onClick={onClick} images={images} style={{ left, top }}>
      <ItemTitle>{title}</ItemTitle>
      {lock && <Lock src={images['lock.png']} />}
    </ItemBlock>
  );
};

const WanderlandHome = ({
  handleBack,
  student,
  config,
  selectWanderlandId,
}) => {
  const { images } = useImagesContext();
  const [items, setItems] = useState(null);
  const [displayLockDialog, setDisplayLockDialog] = useState(false);
  const [displayComingSoon, setDisplayComingSoon] = useState(false);

  useEffect(() => {
    getWanderlandsOfStudent(student.id).then((resp) => {
      console.debug('listWanderland:', resp.data);
      setItems(resp.data);
    });
  }, []);

  return (
    <Container>
      <Background src={images['background.jpg']}></Background>
      {displayLockDialog && (
        <FullScreenCenter src={images['lock-dialog.png']} />
      )}
      {displayComingSoon && (
        <FullScreenCenter src={images['coming-soon.png']} />
      )}
      {items &&
        items.map((value, index) => (
          <WanderlandItem
            key={value.id}
            title={value.title}
            lock={value.canAccess === false}
            left={STAGES_POSITION[index].left}
            top={STAGES_POSITION[index].top}
            onClick={() => {
              if (!value.background) {
                setDisplayComingSoon(true);
                setTimeout(() => {
                  setDisplayComingSoon(false);
                }, 2000);
                return;
              }
              if (value.canAccess) {
                // history.push(`/twilight-zone/${value.id}`);
                selectWanderlandId(value.id);
                // alert('Go to Twilight Zone');
              } else {
                setDisplayLockDialog(true);
                setTimeout(() => {
                  setDisplayLockDialog(false);
                }, 2000);
              }
            }}
          />
        ))}
      {items && !items[0].canAccess && (
        <StageLock src={images['all-stage-locked.png']} alt="" />
      )}
      {items && !items[5].canAccess && (
        <StageLock src={images['stage-locked.png']} alt="" />
      )}
      <Home src={images['home.png']} onClick={handleBack} />;
      <ReactSound
        url={backgroundSound}
        playStatus="PLAYING"
        loop={true}
        volume={config.isMutedSound ? 0 : 100}
      ></ReactSound>
    </Container>
  );
};

const Container = styled.div`
  width: 1920px;
  height: 1080px;
  position: relative;
`;

const StageLock = styled.img`
  position: absolute;
  top: 0px;
  right: 0px;
  // object-fit: contain;
  // z-index: 100;
`;

const Background = styled.img`
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  position: absolute;
  object-fit: contain;
`;

const FullScreenCenter = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
const Home = styled(ImgClick)`
  position: absolute;
  top: 16px;
  left: 16px;
`;

const Lock = styled.img`
  // position: absolute;
  // display: block;
  // top: 0;
  // right: 0;
  widht: 50px;
  height: 50px;
  margin-left: 16px;
`;

const ItemBlock = styled.div`
  background: url(${(props) => props.images['unselect.png']}) no-repeat;
  &:hover {
    background: url(${(props) => props.images['select.png']}) no-repeat;
  }
  position: absolute;
  width: 350px;
  height: 69px;
  // border: 3px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-spacing: 10px;
`;

const ItemTitle = styled.div`
  // position: relative;
  font-family: 'PSLxText';
  font-weight: bold;
  font-size: 48px;
  text-stroke: 1px white;
  -webkit-text-stroke: 0.05em white;
  paint-order: stroke fill;
  text-align: center;
  // width: 250px;
  // border: 3px solid black;
`;

const mapStateToProps = ({ student, config }) => ({
  student,
  config,
});

export default connect(mapStateToProps, null)(WanderlandHome);
